import * as axios from '~/utilities/axios'

export const validatePhoneNumber = (phoneNumber) => {
  if (process.env.DISABLE_PHONE_NUMBER_VALIDATION === 'true') return { valid: true }

  return axios.basic
    .post(`/api/v1/utility/validatePhoneNumber`, { phoneNumber })
    .then(({ data }) => data)
    .catch(axios.parseError)
}
